export default "__VITE_ASSET__a82825cb__"